import http from '@/http';

const DadosPixPorEmailService = {
  async enviarDadosPixPorEmail(dadosPix) {
    try {
      const response = await http.post('/api/astec/projetos/pix/qrcode/enviar-email', dadosPix);
      return response.data;
    } catch (error) {
      console.error('Erro ao enviar dados do Pix por email:', error);
      throw error;
    }
  },
};

export default DadosPixPorEmailService;
